import { learningApi } from '../../../../services/api'
import useSWR, { SWRConfiguration } from 'swr'
import { IContentDocumento, IContentExcerto, IContentVideo, LessonObject } from './types'
import { toast } from 'react-toastify'
import { produce } from 'immer'
import { useMemo } from 'react'

interface IParams {
  moduleId: string
  courseId: string
  lessonId: string
  chapterId: string
}

export function useGetLesson({ moduleId, courseId, lessonId, chapterId }: IParams) {
  const token = localStorage.getItem('token')

  const key = token
    ? [
        '/content',
        {
          course: courseId,
          studyModule: moduleId,
          lesson: lessonId,
          minimumApprenticeshipUnit: chapterId,
        },
        token,
      ]
    : null

  const swr = useSWR<LessonObject>(key, fetcher, configuration)

  const [videoContents, excertoContents, documentoContents] = useMemo(() => {
    const video = [] as IContentVideo[]
    const excerto = [] as IContentExcerto[]
    const documento = [] as IContentDocumento[]

    if (!swr.data) return [video, excerto]

    swr.data.contents.forEach((content) => {
      if (content.type === 'video') video.push(content)
      if (content.type === 'excerto') excerto.push(content)
      if (content.type === 'documento') documento.push(content)
    })

    return [video, excerto, documento]
  }, [swr.data])

  const mutateVideo = (params: { videoId: string; properties: Partial<IContentVideo> }) =>
    swr.mutate(
      (data) =>
        produce(data, (draft) => {
          const contents = draft.contents

          const currentVideo = contents.find((content) => content._id === params.videoId)

          if (currentVideo) {
            Object.assign(currentVideo, params.properties)
          }
        }),
      {
        revalidate: false,
      }
    )

  return {
    ...swr,
    mutateVideo,

    videoContents,
    excertoContents,
    documentoContents,
  }
}

const fetcher = ([url, body, token]: [url: string, body: Record<string, any>, token: string]) =>
  learningApi
    .post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)

const configuration: SWRConfiguration = {
  shouldRetryOnError: true,
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (retryCount > 3) {
      toast.error('Não foi possível carregar o conteúdo selecionado')
    } else {
      setTimeout(() => revalidate({ retryCount }), 500)
    }
  },
}

export type TSwrLesson = ReturnType<typeof useGetLesson>
